/**
 * @zh 网络同步类型定义
 * @en Network synchronization type definitions
 */
/**
 * @zh 同步操作类型
 * @en Sync operation type
 */
export var SyncOperation;
(function (SyncOperation) {
    /**
     * @zh 完整快照
     * @en Full snapshot
     */
    SyncOperation[SyncOperation["FULL"] = 0] = "FULL";
    /**
     * @zh 增量更新
     * @en Delta update
     */
    SyncOperation[SyncOperation["DELTA"] = 1] = "DELTA";
    /**
     * @zh 实体生成
     * @en Entity spawn
     */
    SyncOperation[SyncOperation["SPAWN"] = 2] = "SPAWN";
    /**
     * @zh 实体销毁
     * @en Entity despawn
     */
    SyncOperation[SyncOperation["DESPAWN"] = 3] = "DESPAWN";
})(SyncOperation || (SyncOperation = {}));
/**
 * @zh 各类型的字节大小
 * @en Byte size for each type
 */
export const TYPE_SIZES = {
    boolean: 1,
    int8: 1,
    uint8: 1,
    int16: 2,
    uint16: 2,
    int32: 4,
    uint32: 4,
    float32: 4,
    float64: 8,
    string: -1, // 动态长度 | dynamic length
};
/**
 * @zh 同步元数据的 Symbol 键
 * @en Symbol key for sync metadata
 */
export const SYNC_METADATA = Symbol('SyncMetadata');
/**
 * @zh 变更追踪器的 Symbol 键
 * @en Symbol key for change tracker
 */
export const CHANGE_TRACKER = Symbol('ChangeTracker');
//# sourceMappingURL=types.js.map